import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaCardRowLink'

type IcaCardRowLinkProps = React.JSX.IntrinsicElements['tgdb-ica-card-row-link']

export const IcaCardRowLink = wrapWc<IcaCardRowLinkProps>('tgdb-ica-card-row-link', [])